import { Injectable } from '@angular/core';
import { TimeSlotInterface } from '@app/core/interfaces';
import { LocationInterface } from '@app/core/interfaces/location.interface';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import { RequestService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const GLASS_REPAIR_CODE = 'GLSH';

@Injectable({
    providedIn: 'root',
})
export class AppointmentService {

    constructor(private request: RequestService) {}

    public requestAppointmentLocations(
        appointment: ClaimAppointmentInterface,
        caseSequenceNumber: number,
        networkId: string,
        postalCode: string,
    ): Observable<LocationInterface[]> {
        const payload = {
            case: {
                case_sequence_number: caseSequenceNumber,
            },
            network_id: networkId,
            postal_code: postalCode,
            damage_repair_event_code: appointment.gebeurtenis.schadeherstel_gebeurtenis_code,
        };

        if (appointment.gebeurtenis.schadeherstel_gebeurtenis_code === GLASS_REPAIR_CODE) {
            delete payload.network_id;
        }

        return this.request.post('en-gb/damage-appointment-calendar/request/locations', payload)
            .pipe(
                map((response) => response.data),
                map(data => data.locations),
            );
    }

    public requestAppointmentTimeslots(
        appointment: ClaimAppointmentInterface,
        addressRelationId: number,
        caseSequenceNumber: number,
        networkId: string,
        preferredDate: string,
    ): Observable<{ time_slots: TimeSlotInterface[] }> {
        const payload = {
            business_relation_id: addressRelationId,
            case: {
                case_sequence_number: caseSequenceNumber,
            },
            network_id: networkId,
            preferred_date: preferredDate,
            damage_repair_event_code: appointment.gebeurtenis.schadeherstel_gebeurtenis_code,
        };

        if (appointment.gebeurtenis.schadeherstel_gebeurtenis_code === GLASS_REPAIR_CODE) {
            delete payload.network_id;
        }

        return this.request.post('en-gb/damage-appointment-calendar/request/timeslots', payload)
            .pipe(map((res) => {
                if (res.data.time_slots) {
                    return res.data;
                } else {
                    return res.messages;
                }
            }));
    }
}
